<script lang="ts">
    import { MoneyModule } from "@modules/money/MoneyModule";
    import { BehaviorSubject, combineLatest } from "rxjs";
    import { map, switchMap } from "rxjs/operators";
    import { container } from "tsyringe";

    const moneyModule = container.resolve(MoneyModule);

    export let with_currency = false;
    export let amount: number;
    const withCurrency$ = new BehaviorSubject(with_currency);
    const amount$ = new BehaviorSubject(amount);
    const currencyProvider = moneyModule.exports.currencyProvider;
    const exchanger = moneyModule.exports.moneyExchanger;
    const formatter = moneyModule.exports.moneyFormatter;
    const sanitizer = moneyModule.exports.htmlSanitizer;
    let formated$ = combineLatest([
        currencyProvider.selectCurrency(),
        amount$,
    ]).pipe(
        switchMap(([currency, amount]) => {
            return combineLatest([
                exchanger.exchange(amount, currency),
                withCurrency$,
            ]);
        }),
        map(([exchangedAmount, withCurrency]) => {
            return withCurrency
                ? formatter.format_with_currency(exchangedAmount)
                : formatter.format(exchangedAmount);
        })
    );
    let escapedFormated$ = sanitizer.sanitize$(formated$);
    $: {
        withCurrency$.next(with_currency);
        amount$.next(amount);
    }
</script>

{@html $escapedFormated$}
